<template>
  <div class="staff-list-block staff-list-block--group">
    <div v-if="groupHeading" class="staff-list-block__header">
      <p class="text-TTDrugs-Bold-40 color-green center text-uppercase">{{ groupHeading }}</p>
      <p v-if="groupSubheading" class="text-circe-20 color-gray center">{{ groupSubheading }}</p>
    </div>
    <div v-if="loadError" class="staff-list-block__error text-circe-18 color-gray">
      Не удалось загрузить список специалистов
    </div>
    <AppLoader v-else-if="loading" />
    <AppDoctorsPeopleList v-else-if="peopleList.length" :people_list="peopleList" />
  </div>
</template>

<script>
import DepartmentAPi from "@/api/department";
import AppDoctorsPeopleList from "@/components/People/DoctorsPeopleList.vue";
import AppLoader from "@/components/Loader.vue";

function extractEmployeeList(res) {
  const body = res && res.data !== undefined ? res.data : res;
  if (Array.isArray(body)) {
    return body;
  }
  if (body && body.status === "SUCCESS" && Array.isArray(body.result)) {
    return body.result;
  }
  return [];
}

export default {
  name: "AppStaffListGroupBlock",
  components: { AppDoctorsPeopleList, AppLoader },
  props: {
    /** Массив data из подряд идущих блоков staff_list на динамической странице */
    blocks: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: true,
      loadError: false,
      peopleList: [],
    };
  },
  computed: {
    groupHeading() {
      const withHeading = (this.blocks || []).find((b) => b && String(b.heading || "").trim());
      return withHeading ? withHeading.heading : "";
    },
    groupSubheading() {
      const withSub = (this.blocks || []).find((b) => b && String(b.subheading || "").trim());
      return withSub ? withSub.subheading : "";
    },
  },
  watch: {
    blocks: {
      deep: true,
      handler() {
        this.loadPeople();
      },
    },
  },
  mounted() {
    this.loadPeople();
  },
  methods: {
    normalizePerson(emp) {
      if (!emp) {
        return null;
      }
      const rawId = emp.id != null ? emp.id : emp._id;
      if (rawId === undefined || rawId === null || String(rawId).trim() === "") {
        return null;
      }
      return {
        ...emp,
        id: String(rawId).trim(),
        opening: emp.openingHours || emp.opening || "",
      };
    },

    mergeOrderedManualThenSubDept(manualList, subDeptList) {
      const seen = new Set();
      const out = [];
      for (const raw of manualList || []) {
        const p = this.normalizePerson(raw);
        if (p && !seen.has(p.id)) {
          seen.add(p.id);
          out.push(p);
        }
      }
      for (const raw of subDeptList || []) {
        const p = this.normalizePerson(raw);
        if (p && !seen.has(p.id)) {
          seen.add(p.id);
          out.push(p);
        }
      }
      return out;
    },

    collectLoadTasks() {
      const tasks = [];
      for (const data of this.blocks || []) {
        if (!data) continue;
        const useManual = !!data.useManualList && Array.isArray(data.employeeIds) && data.employeeIds.length > 0;
        const useSub = !!data.useSubDepartment && !!String(data.subDepartmentName || "").trim();
        if (!useManual && !useSub) continue;

        const ids = (data.employeeIds || []).map((id) => String(id).trim()).filter(Boolean);
        tasks.push({
          manual: useManual
            ? DepartmentAPi.postEmployeesByIds(ids)
            : Promise.resolve({ data: [] }),
          sub: useSub
            ? DepartmentAPi.getDoctorsUnderDepartment(String(data.subDepartmentName).trim())
            : Promise.resolve({ data: [] }),
        });
      }
      return tasks;
    },

    async loadPeople() {
      const tasks = this.collectLoadTasks();
      if (!tasks.length) {
        this.loading = false;
        this.loadError = false;
        this.peopleList = [];
        return;
      }

      this.loading = true;
      this.loadError = false;
      try {
        const results = await Promise.all(
          tasks.map((t) => Promise.all([t.manual, t.sub]))
        );
        let peopleList = [];
        for (const [manualRes, subRes] of results) {
          const manual = extractEmployeeList(manualRes);
          const sub = extractEmployeeList(subRes);
          peopleList = this.mergeOrderedManualThenSubDept(
            peopleList.concat(manual),
            sub
          );
        }
        this.peopleList = peopleList;
      } catch (e) {
        this.loadError = true;
        this.peopleList = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.staff-list-block {
  width: 100%;
}

.staff-list-block__header {
  margin-bottom: 20px;
}

.staff-list-block__error {
  padding: 16px 0;
}
</style>
